"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FieldReader_1 = require("../../core/conversions/FieldReader");

var WindowItemForecast_1 = require("../model/WindowItemForecast");

var WindowItemForecastConverter_1 = require("./WindowItemForecastConverter");
/**
 * Default implementation of WindowPromoEffectConverter.
 *
 * @author Stepan Mik
 */


var WindowItemForecastConverterImpl =
/*#__PURE__*/
function (_WindowItemForecastCo) {
  _inherits(WindowItemForecastConverterImpl, _WindowItemForecastCo);

  function WindowItemForecastConverterImpl() {
    var _this;

    _classCallCheck(this, WindowItemForecastConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemForecastConverterImpl).apply(this, arguments));
    _this.materializer = WindowItemForecast_1.WindowItemForecast.fromMat;
    _this.readers = {
      id: FieldReader_1.FieldReader.fromDocIdDesc(WindowItemForecast_1.WindowItemForecast.schema.id),
      date: FieldReader_1.FieldReader.fromDateDesc(WindowItemForecast_1.WindowItemForecast.schema.date),
      promoWeek: FieldReader_1.FieldReader.fromDesc(WindowItemForecast_1.WindowItemForecast.schema.promoWeek),
      calendarWeek: FieldReader_1.FieldReader.fromDesc(WindowItemForecast_1.WindowItemForecast.schema.calendarWeek),
      windowId: FieldReader_1.FieldReader.fromIdDesc(WindowItemForecast_1.WindowItemForecast.schema.windowId),
      windowItemId: FieldReader_1.FieldReader.fromIdDesc(WindowItemForecast_1.WindowItemForecast.schema.windowItemId),
      productId: FieldReader_1.FieldReader.fromIdDesc(WindowItemForecast_1.WindowItemForecast.schema.productId),
      amount: FieldReader_1.FieldReader.fromNumDesc(WindowItemForecast_1.WindowItemForecast.schema.amount),
      splitOption: FieldReader_1.FieldReader.fromDesc(WindowItemForecast_1.WindowItemForecast.schema.splitOption)
    };
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowItemForecastConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        windowId: conversions.toDocumentReferenceId(source.windowId),
        productId: conversions.toDocumentReferenceId(source.productId),
        date: conversions.fromDate(source.date),
        amount: conversions.fromBigNumber(source.amount),
        calendarWeek: source.calendarWeek,
        promoWeek: source.promoWeek,
        splitOption: source.splitOption
      });
      return result;
    }
  }]);

  return WindowItemForecastConverterImpl;
}(WindowItemForecastConverter_1.WindowItemForecastConverter);

exports.WindowItemForecastConverterImpl = WindowItemForecastConverterImpl;